<template>
  <div class="row">
    <Loader v-if="!resourceLoaded" />
    <SendInvoiceModal ref="sendInvoiceModal" id="send-invoice-modal" />
    <div class="col-12" v-if="resourceLoaded">
      <div class="panel-content-inner">
        <div class="row">
          <table
            id="reservations-table"
            class="superconciergerie-table table table-responsive"
          >
            <thead>
              <tr>
                <th style="text-align:left; padding-left:25px !important">{{ $t("superconcierge.facturation.rental_owner") }}</th>
                <th>{{ $t("superconcierge.facturation.month") }}</th>
                <th style="font-weight: bold">
                  {{ $t("superconcierge.facturation.total_gross_revenue") }}
                </th>
                <th style="width:150px">{{ $t("superconcierge.facturation.status") }}</th>
                <th>{{ $t("superconcierge.facturation.action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="owner in filteredMappedOwners" :key="owner.id + '-' + owner.month + '-' + owner.year">
                <td>
                  <div style="text-align:left; padding-left:25px !important">{{ owner.name }}</div>
                </td>
                <td>
                  <div>
                    {{
                      capitalize(moment(owner.month).lang("fr").format("MMMM YYYY"))
                    }}
                  </div>
                </td>
                <td>
                  <div style="font-weight: 600;">{{ owner.total_due.toFixed(2) + " " + owner.currency }}</div>
                </td>
                <td>
                    <dropdown-selector
                      :id="owner.id"
                      :options="[
                      {
                        id:'pending',
                        name: $t('superconcierge.facturation.status_list.waiting'),
                      },
                      {
                        id:'to_pay',
                        name: $t('superconcierge.facturation.status_list.to_pay'),
                      },
                      {
                        id:'paid',
                        name: $t('superconcierge.facturation.status_list.paid'),
                      },
                      {
                        id:'closed',
                        name: $t('superconcierge.facturation.status_list.closed'),
                      }
                    ]"
                      :default-selected="owner.invoice_status"
                      @update:selected="updateInvoiceStatus(owner, $event)"
                    />
                </td>
                <td>
                  <div>
                    <div class="dropdown dropdown_btn" style="position:relative; display: inline !important;">
                      <button
                        class="btn btn-red btn-bold waves-effect waves-classic btn-with-caret text-white btn-with-caret"
                        style="font-size: 14px; padding: 4px 12px !important"
                        type="button"
                        data-toggle="dropdown"
                      >
                        {{ $t("button.actions") }}
                        <span class="dropdown-toggle"></span>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-right" style="top: 50px">
                        <li>
                          <a
                            :href="'/#/superconcierge/invoice/'+owner.id+'/'+owner.month.split('-')[0]+'/'+owner.month.split('-')[1]"
                            target="_blank"
                            style="text-decoration:none"
                          >{{ $t("superconcierge.facturation.edit_invoice") }}</a>
                        </li>
                        <li>
                          <a
                            href=""
                            @click.prevent="$refs.sendInvoiceModal.open(owner.id,owner.month.split('-')[0],owner.month.split('-')[1])"
                            style="text-decoration:none"
                            >{{ $t("superconcierge.facturation.send_invoice") }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
 td {
   color:#757575 !important;
 }
</style>
<script>
import Vue from 'vue';
import moment from "moment";
import superconciergerie from "../../../services/superconciergerie";
import mixin from "../../../mixins/mixin";
export default {
  data() {
    return {
      resourceLoaded: false,
      mappedOwners: [],
      filteredMappedOwners: [],
      owners: [],
      filteredOwners: [],
      filteredOwnerIds: [],
      permalink: "",
    };
  },
  mixins: [mixin],
  methods: {
    moment: function (date, format) {
      return moment(date, format);
    },
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async loadResource() {
      if (this.activeTab === "facturation" && !this.resourceLoaded) {
        await superconciergerie.getMappedOwners(this);

        this.$root.$emit('facturation_owners_setFilterElems', this.filteredOwners);
        this.$root.$emit('facturation_owners_setFilterFallback',(ids) => this.filterData(ids, this, "owners"));

        this.$root.$emit('facturation_dates_setDateFilterFallback',(date) => {
          this.resourceLoaded = false;
          superconciergerie.getMappedOwners(this, date)
            .then(() => {
              this.resourceLoaded = true;
              this.filteredMappedOwners = this.mappedOwners.filter((owner) => {
                const ownerMatch = !this.filteredOwnerIds.length || this.filteredOwnerIds.includes(owner.id);

                return ownerMatch;
              });
            });
        });

        this.resourceLoaded = true;
      }
    },
    filterData(filteredIds, context, target) {
      context.filteredOwnerIds = filteredIds;

      context.filteredMappedOwners = this.mappedOwners.filter((mO) => {
        const ownerMatch = !context.filteredOwnerIds.length || context.filteredOwnerIds.includes(mO.id);

        return ownerMatch;
      });
    },
    async filter(filteredIDs) {
      if(filteredIDs.length > 0) {
        this.filteredMappedOwners = this.mappedOwners.filter((owner) => {
          return filteredIDs.includes(owner.id);
        });
      } else {
        this.filteredMappedOwners = this.mappedOwners;
      }
    },
    async sendInvoice() {
      await superconciergerie.sendInvoice(this);
    },
    async editInvoice() {
      await superconciergerie.editInvoice(this);
    },
    async updateInvoiceStatus(mappedOwner, status) {
      if(mappedOwner.invoice_status != status) {
        mappedOwner.invoice_status = status;
        await superconciergerie.updateInvoiceStatus(this, mappedOwner);
      }
    },
    goToInvoice(ownerId, month, year, type = 'detailed') {
      Vue.router.push({
        name: 'superconcierge.tab',
        params: {
          tab: "invoice",
          ownerId,
          year,
          month,
          type
       },
      });
      Vue.nextTick(() => {
        window.location.reload();
      });
    },
  },
  props: ["activeTab"],
  async mounted() {
    // await this.loadResource();
  },
  watch: {
    activeTab: async function (val) {
      await this.loadResource();
    },
    mappedOwners: async function (val) {
      // Get owners
      this.owners = this.mappedOwners.map(mO => {
        return {
          'id': mO.id,
          'name': mO.name,
        }
      });
      this.owners = this.owners.filter(o => o != null);
      this.owners = this.owners.filter((owner, index, self) =>
          index === self.findIndex((t) => (
            t.id === owner.id
          ))
      );
      this.filteredOwners = this.owners;
    },
  },
  components: {
    Loader: require('../components/Loader.vue'),
    SendInvoiceModal: require('./../modals/sendInvoiceModal.vue'),
    DropdownSelector: require('../components/DropdownSelector.vue'),
  },
};
</script>



// WEBPACK FOOTER //
// FacturationTab.vue?84a9e130